import React from 'react';
import { Link } from 'react-router-dom';
import useMediaQuery from '../../hooks/useMediaQuery';

import styles from './Header.module.css';

const TechHeader = () => {
  const mobileNavigationDialogRef = React.useRef(null);
  const isMobile = useMediaQuery("(max-width: 768px)");

  const handleNavClick = async (linkType) => {
    mobileNavigationDialogRef?.current?.close();

    const { logAnalyticsEvent } = await import('../../utils/analyticsUtils');
    logAnalyticsEvent('nav_link_click', {
      link_type: linkType
    });
  };

  const handleMenuOpen = () => {
    mobileNavigationDialogRef?.current?.showModal();
  };

  const handleMenuClose = () => {
    mobileNavigationDialogRef?.current?.close();
  };

  if (!isMobile) return (
    <nav className={styles.headerContainer} aria-label="Primary">
      <ul className={styles.listContainer}>
        <li className={styles.topBarNavItem}><Link className={styles.navLink} to="/" onClick={() => handleNavClick('home')}>HOME</Link></li>

        <li className={`${styles.topBarNavItem} ${styles.pushRight}`}><Link className={styles.navLink} to="/projects" onClick={() => handleNavClick('projects')}>PROJECTS</Link></li>
        <li className={styles.topBarNavItem}><Link className={styles.navLink} to="/work" onClick={() => handleNavClick('work')}>WORK</Link></li>
        <li className={styles.topBarNavItem}><Link className={styles.navLink} to="/teaching" onClick={() => handleNavClick('teaching')}>TEACHING</Link></li>
      </ul>
    </nav>
  );

  return (
    <nav className={styles.headerContainer} aria-label="Primary">
      <ul className={styles.listContainer}>
        <li className={styles.topBarNavItem}>
          <Link className={styles.navLink} to="/" onClick={() => handleNavClick('home')}>HOME</Link></li>

        <li className={`${styles.topBarNavItem} ${styles.pushRight}`}>
          <button
            type="button"
            className={`iconButton ${styles.menuToggleButton}`}
            onClick={handleMenuOpen}
            aria-label="Open menu"
            aria-haspopup="dialog"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon lucide lucide-menu-icon lucide-menu" aria-hidden="true"><path d="M4 5h16" /><path d="M4 12h16" /><path d="M4 19h16" /></svg>
          </button>
        </li>
      </ul>

      <dialog ref={mobileNavigationDialogRef} id="popup-navigation-menu" aria-label="Popup navigation menu" className={styles.fullScreenModal}>
        <header>
          {/* BUG: Dialog applies focus-visible and focus pseudoclasses instead of just focus on the close button. It also applies both on press from mobile, when it should only do so when navigated to by a keyboard */}
          {/* https://github.com/radix-ui/primitives/issues/2545 */}
          <button
            type="button"
            className={`iconButton ${styles.menuToggleButton}`}
            onClick={handleMenuClose}
            aria-label="Close menu"
            style={{ outline: "none" }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon lucide lucide-x-icon lucide-x" aria-hidden="true"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
          </button>
        </header>

        <nav className={styles.modalBodyContainer}>
          <ul className={styles.mobileLinksContainer}>
            <li className={styles.dialogNavItem}>
              <Link className={styles.navLink} to="/" onClick={() => handleNavClick('home')}>HOME</Link>
            </li>

            <li className={styles.dialogNavItem}>
              <Link className={styles.navLink} to="/projects" onClick={() => handleNavClick('projects')}>
                PROJECTS
              </Link>
            </li>
            <li className={styles.dialogNavItem}>
              <Link className={styles.navLink} to="/work" onClick={() => handleNavClick('work')}>
                WORK
              </Link>
            </li>
            <li className={styles.dialogNavItem}>
              <Link className={styles.navLink} to="/teaching" onClick={() => handleNavClick('teaching')}>
                TEACHING
              </Link>
            </li>
          </ul>
        </nav>
      </dialog>
    </nav>
  );
}

export default TechHeader;